import React from 'react';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Chip,
  Typography,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ConditionsEditor from './ConditionsEditor';

const FlowConditionBlock = ({
  title,
  description,
  scope,
  conditions,
  conditionLogic,
  tags,
  dataSources,
  onConditionsChange,
  onConditionLogicChange,
}) => (
  <Accordion disableGutters elevation={0} sx={{ border: '1px solid', borderColor: 'divider', borderRadius: '10px !important', mb: 1 }}>
    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
      <Box sx={{ minWidth: 0, flex: 1 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography fontWeight={700}>{title}</Typography>
          <Chip size="small" label={conditions.length} />
        </Box>
        <Typography variant="caption" color="text.secondary">{description}</Typography>
      </Box>
    </AccordionSummary>
    <AccordionDetails sx={{ px: 1.5, pb: 1.5 }}>
      <ConditionsEditor
        useConditions
        onUseConditionsChange={() => {}}
        conditions={conditions}
        onConditionsChange={onConditionsChange}
        conditionLogic={conditionLogic}
        onConditionLogicChange={onConditionLogicChange}
        tags={tags}
        dataSources={dataSources}
        scope={scope}
        hideHeader
      />
    </AccordionDetails>
  </Accordion>
);

const FlowConditionsSection = ({
  eventConditions = [],
  eventConditionLogic = 'AND',
  projectConditions = [],
  projectConditionLogic = 'AND',
  tags = [],
  dataSources = [],
  onEventConditionsChange,
  onEventConditionLogicChange,
  onProjectConditionsChange,
  onProjectConditionLogicChange,
  t,
}) => (
  <Box sx={{ mt: 2 }}>
    <Typography variant="overline" sx={{ display: 'block', fontWeight: 800, color: 'primary.main', mb: 0.5 }}>
      {t('workflow.flow_conditions_heading', 'WHEN')}
    </Typography>
    <FlowConditionBlock
      title={t('workflow.flow_event_conditions_title', 'Event conditions')}
      description={t('workflow.flow_event_conditions_help', 'Filter the timeevents processed by this flow.')}
      scope="event"
      conditions={eventConditions}
      conditionLogic={eventConditionLogic}
      tags={tags}
      dataSources={dataSources}
      onConditionsChange={onEventConditionsChange}
      onConditionLogicChange={onEventConditionLogicChange}
    />
    <FlowConditionBlock
      title={t('workflow.flow_project_conditions_title', 'Project conditions')}
      description={t('workflow.flow_project_conditions_help', 'Gate the entire flow using project-level values.')}
      scope="project"
      conditions={projectConditions}
      conditionLogic={projectConditionLogic}
      tags={tags}
      dataSources={dataSources}
      onConditionsChange={onProjectConditionsChange}
      onConditionLogicChange={onProjectConditionLogicChange}
    />
  </Box>
);

export default React.memo(FlowConditionsSection);
